
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { useTheme } from '@/context/ThemeContext';
import { Moon, Sun } from 'lucide-react';

const AppearanceSettings = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Card>
      <CardHeader className="text-center sm:text-left">
        <CardTitle>Appearance</CardTitle>
        <CardDescription>
          Customize how KidQuotes looks on your device
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex flex-col sm:flex-row justify-between items-center sm:items-start gap-4">
            <div className="w-full text-center sm:text-left">
              <Label htmlFor="theme" className="block font-medium">Theme</Label>
              <p className="text-sm text-muted-foreground mt-1">
                Choose between light and dark mode
              </p>
            </div>
            <Button 
              variant="outline" 
              onClick={toggleTheme}
              className="min-w-[120px] flex items-center justify-center gap-2"
            >
              {theme === 'dark' ? (
                <>
                  <Sun className="h-4 w-4" />
                  <span>Light</span>
                </>
              ) : (
                <>
                  <Moon className="h-4 w-4" />
                  <span>Dark</span>
                </>
              )}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AppearanceSettings;
